import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { learnApi } from './api/learn';
import { roleLabel, roleLabelsText, type RoleLabels } from './role-labels';

const NO_LABELS: RoleLabels = {};

/**
 * Русские названия ролей для экранов вики. Справочник (роли CRM + должности iiko) грузим один раз
 * на сессию из GET /wiki/education/role-labels — он доступен и ученикам; пока он не пришёл (или упал),
 * работает запасная карта и «человеческий» вид кода (см. role-labels.ts).
 * `extra` — справочник, который экран уже имеет (assign-options конструктора): он точнее и идёт первым.
 */
export function useRoleLabels(extra?: RoleLabels | null): {
  labels: RoleLabels;
  label: (code: string | null | undefined) => string;
  text: (codes: readonly string[] | null | undefined, empty?: string) => string;
} {
  const q = useQuery({ queryKey: ['wiki', 'education', 'role-labels'], queryFn: () => learnApi.roleLabels(), staleTime: 10 * 60_000, retry: false });
  const server = q.data?.labels ?? NO_LABELS;
  const labels = useMemo<RoleLabels>(() => (extra ? { ...server, ...extra } : server), [server, extra]);
  const label = useCallback((code: string | null | undefined) => roleLabel(code, labels), [labels]);
  const text = useCallback((codes: readonly string[] | null | undefined, empty?: string) => roleLabelsText(codes, labels, empty), [labels]);
  return { labels, label, text };
}
